// extracted by mini-css-extract-plugin
export default {"ColorTile":"styles_ColorTile__cBeza","inner":"styles_inner__QbMQi","active":"styles_active__4NCjg","outer":"styles_outer__I9YmR"};